export default __webpack_public_path__ + "static/media/incompability-icon.dec23416.svg";